import { auth, functionsBaseUrl } from "../../firebase";
import { ClaimDiscountRequest, ClaimDiscountResponse } from "../../models/discountType";


export const DiscountsApiService = {
  issueDiscount: async (userId: string, eventId: string): Promise<ClaimDiscountResponse | undefined> => {
    if (!auth.currentUser) {
      return undefined;
    }

    const idToken: string = await auth.currentUser.getIdToken()
    const body: ClaimDiscountRequest = {
      eventId,
      userId,
    }

    const response = await fetch(`${functionsBaseUrl}/issueDiscount`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    console.log(response)
    if (response.status === 200) {
      return ((await response.json()) as ClaimDiscountResponse);
    } 
    return undefined;
  },
};

